export class PharmDashboardService {
  constructor(pharmDashboardRepository) {
    this.pharmDashboardRepository = pharmDashboardRepository;
  }

  async getVisitKpi() {
    return await this.pharmDashboardRepository.getVisitKpi();
  }

  async getPrescriptionKpi() {
    return await this.pharmDashboardRepository.getPrescriptionKpi();
  }

  async getPatients(page = 1, limit = 20) {
    return await this.pharmDashboardRepository.getPatients(page, limit);
  }

  async getCouponSummary(pharmacyBrn) {
    if (!pharmacyBrn) throw new Error('사업자등록번호가 필요합니다.');
    return await this.pharmDashboardRepository.getCouponSummary(pharmacyBrn);
  }

  async getPointSummary(pharmacyBrn) {
    if (!pharmacyBrn) throw new Error('사업자등록번호가 필요합니다.');
    return await this.pharmDashboardRepository.getPointSummary(pharmacyBrn);
  }

  // 약국 토큰 기준 — brn 불필요
  async getActionRequiredKpi() {
    return await this.pharmDashboardRepository.getActionRequiredKpi();
  }

  async getActiveEvents() {
    return await this.pharmDashboardRepository.getActiveEvents();
  }

  async getAdCampaigns() {
    return await this.pharmDashboardRepository.getAdCampaigns();
  }

  async setAdCampaignJoin(campaignId, join) {
    return await this.pharmDashboardRepository.setAdCampaignJoin(campaignId, join);
  }

  async getRecommendationHits(pharmacyBrn, params = {}) {
    if (!pharmacyBrn) throw new Error('사업자등록번호가 필요합니다.');
    return await this.pharmDashboardRepository.getRecommendationHits(pharmacyBrn, params);
  }
}
